

import { listadoTraslados } from '../../../components/Traslados/RegistrarTraslados';
import {
    FILTRO_LISTA_TRASLADOS_REQUEST,
    FILTRO_LISTA_TRASLADOS_SUCCESS,
    FILTRO_LISTA_TRASLADOS_FAIL
} from '../../actions/Traslados/types'

// Define el tipo para el estado inicial
interface PropsState {
    filtroListadoTraslados: listadoTraslados[];
}
// Estado inicial tipado
const initialState: PropsState = {
    filtroListadoTraslados: []
};

// Reducer con tipos definidos
const filtroListadoTrasladosReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case FILTRO_LISTA_TRASLADOS_REQUEST:
            return { ...state, loading: true };
        case FILTRO_LISTA_TRASLADOS_SUCCESS:
            return {
                ...state,
                loading: false,
                filtroListadoTraslados: action.payload,
            };
        case FILTRO_LISTA_TRASLADOS_FAIL:
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};



export default filtroListadoTrasladosReducers;
